import React from 'react';
import { PreviewComponent } from './PreviewFruit';

const PreviewButchery = props => (
    <div className="PreviewFruit">
        <div className={'CenterFruit o' + props.orientation}>
            <div className="PreviewFruitContainer">
                <PreviewComponent rayon="butchery" {...props} />
            </div>
        </div>
    </div>
);

export default PreviewButchery;
